export enum CreativeTypeNamesAllowsVastBuilder {
  VASTVideoCreativeV5 = 'VASTVideoCreativeV5',
  MagniteCreativeV5 = 'MagniteCreativeV5',
  DraxCreativeV5 = 'DraxCreativeV5',
}
